import { render, staticRenderFns } from "./ZyroPopupCard.vue?vue&type=template&id=6ec860f7&scoped=true&"
import script from "./ZyroPopupCard.vue?vue&type=script&lang=js&"
export * from "./ZyroPopupCard.vue?vue&type=script&lang=js&"
import style0 from "./ZyroPopupCard.vue?vue&type=style&index=0&id=6ec860f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec860f7",
  null
  
)

export default component.exports